import { render, staticRenderFns } from "./DetalleTutoria.vue?vue&type=template&id=1d242903&"
import script from "./DetalleTutoria.vue?vue&type=script&lang=js&"
export * from "./DetalleTutoria.vue?vue&type=script&lang=js&"
import style0 from "./DetalleTutoria.vue?vue&type=style&index=0&id=1d242903&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports